import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Select from 'react-select';
import DashboardFooter from '../components/DashboardFooter';

const URL_API = `${process.env.REACT_APP_HOST_API_URL}/admin-user/url-permissions/`;
const URL_ADD_API = `${process.env.REACT_APP_HOST_API_URL}/admin-user/url-permissions/add/`;
const URL_UPDATE_API = `${process.env.REACT_APP_HOST_API_URL}/admin-user/url-permissions/update/`;
const URL_DELETE_API = `${process.env.REACT_APP_HOST_API_URL}/admin-user/url-permissions/delete/`;

/* ─── inline styles ─────────────────────────────────────────────────── */
const styles = {
    page: {
        minHeight: '100vh',
        backgroundColor: '#f0f4f9',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: "'DM Sans', sans-serif",
    },
    main: {
        flex: 1,
        padding: '32px 24px',
        maxWidth: 1200,
        margin: '0 auto',
        width: '100%',
    },

    /* header banner */
    banner: {
        background: 'linear-gradient(135deg, #1a56db 0%, #3b82f6 60%, #60a5fa 100%)',
        borderRadius: 16,
        padding: '28px 32px',
        marginBottom: 28,
        margin: 30,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 16,
        boxShadow: '0 8px 32px rgba(26,86,219,0.18)',
    },
    bannerTitle: {
        color: '#fff',
        fontSize: 24,
        fontWeight: 700,
        margin: 0,
        letterSpacing: '-0.3px',
    },
    bannerSub: {
        color: 'rgba(255,255,255,0.78)',
        fontSize: 14,
        margin: '4px 0 0',
    },
    bannerBtns: {
        display: 'flex',
        gap: 10,
    },
    btnOutlineWhite: {
        background: 'transparent',
        border: '1.5px solid rgba(255,255,255,0.6)',
        color: '#fff',
        borderRadius: 8,
        padding: '8px 20px',
        fontSize: 14,
        fontWeight: 500,
        cursor: 'pointer',
        transition: 'background 0.18s, border-color 0.18s',
    },
    btnSolidWhite: {
        background: '#fff',
        border: '1.5px solid #fff',
        color: '#1a56db',
        borderRadius: 8,
        padding: '8px 20px',
        fontSize: 14,
        fontWeight: 600,
        cursor: 'pointer',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    },

    /* card */
    card: {
        background: '#fff',
        borderRadius: 16,
        boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
        marginBottom: 28,
        overflow: 'visible',
    },
    cardHeader: {
        padding: '20px 28px 0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 12,
        marginTop: 10,
        marginBottom: 10
    },
    cardTitle: {
        fontSize: 18,
        fontWeight: 700,
        color: '#111827',
        margin: 0,
    },
    cardBody: {
        padding: '20px 28px 28px',
    },

    /* form */
    formGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
        gap: '16px 20px',
        marginBottom: 20,
    },
    formGridFull: {
        gridColumn: '1 / -1',
    },
    label: {
        display: 'block',
        fontSize: 13,
        fontWeight: 600,
        color: '#374151',
        marginBottom: 6,
        letterSpacing: '0.01em',
    },
    input: {
        width: '100%',
        padding: '9px 14px',
        border: '1.5px solid #d1d5db',
        borderRadius: 8,
        fontSize: 14,
        color: '#111827',
        outline: 'none',
        transition: 'border-color 0.18s',
        boxSizing: 'border-box',
        background: '#fafafa',
    },
    formActions: {
        display: 'flex',
        gap: 10,
        marginTop: 8,
    },
    btnPrimary: {
        background: 'linear-gradient(135deg, #1a56db, #3b82f6)',
        color: '#fff',
        border: 'none',
        borderRadius: 8,
        padding: '9px 26px',
        fontSize: 14,
        fontWeight: 600,
        cursor: 'pointer',
        boxShadow: '0 2px 8px rgba(26,86,219,0.18)',
    },
    btnSecondary: {
        background: '#f3f4f6',
        color: '#374151',
        border: '1.5px solid #e5e7eb',
        borderRadius: 8,
        padding: '9px 22px',
        fontSize: 14,
        fontWeight: 500,
        cursor: 'pointer',
    },
    btnSuccess: {
        background: 'linear-gradient(135deg, #1a56db, #3b82f6)',
        color: '#fff',
        border: 'none',
        borderRadius: 8,
        padding: '8px 18px',
        fontSize: 13,
        fontWeight: 600,
        cursor: 'pointer',
    },

    /* table */
    tableWrap: {
        overflowX: 'auto',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: 14,
    },
    th: {
        background: '#f8fafc',
        color: '#6b7280',
        fontWeight: 600,
        fontSize: 12,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        padding: '11px 16px',
        textAlign: 'left',
        borderBottom: '1.5px solid #e5e7eb',
        whiteSpace: 'nowrap',
    },
    td: {
        padding: '13px 16px',
        borderBottom: '1px solid #f3f4f6',
        color: '#111827',
        verticalAlign: 'middle',
    },
    tdMuted: {
        padding: '13px 16px',
        borderBottom: '1px solid #f3f4f6',
        color: '#6b7280',
        verticalAlign: 'middle',
    },
    code: {
        background: '#eff6ff',
        color: '#1d4ed8',
        borderRadius: 5,
        padding: '3px 8px',
        fontSize: 13,
        fontFamily: "'Fira Mono', monospace",
    },
    badge: {
        display: 'inline-block',
        background: '#eff6ff',
        color: '#1d4ed8',
        borderRadius: 20,
        padding: '3px 10px',
        fontSize: 12,
        fontWeight: 500,
        marginRight: 4,
        marginBottom: 2,
    },
    actionBtns: {
        display: 'flex',
        gap: 8,
    },
    btnEdit: {
        background: '#fffbeb',
        color: '#92400e',
        border: '1px solid #fde68a',
        borderRadius: 7,
        padding: '5px 14px',
        fontSize: 13,
        fontWeight: 500,
        cursor: 'pointer',
    },
    btnDelete: {
        background: '#fff1f2',
        color: '#be123c',
        border: '1px solid #fecdd3',
        borderRadius: 7,
        padding: '5px 14px',
        fontSize: 13,
        fontWeight: 500,
        cursor: 'pointer',
    },
    emptyRow: {
        textAlign: 'center',
        padding: '48px 16px',
        color: '#9ca3af',
        fontSize: 14,
    },
};

/* react-select custom styles to match the design */
const selectStyles = {
    control: (base, state) => ({
        ...base,
        borderRadius: 8,
        borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
        boxShadow: state.isFocused ? '0 0 0 3px rgba(59,130,246,0.15)' : 'none',
        background: '#fafafa',
        fontSize: 14,
        minHeight: 40,
        '&:hover': { borderColor: '#3b82f6' },
    }),
    multiValue: (base) => ({
        ...base,
        background: '#eff6ff',
        borderRadius: 5,
    }),
    multiValueLabel: (base) => ({
        ...base,
        color: '#1d4ed8',
        fontSize: 13,
        fontWeight: 500,
    }),
    multiValueRemove: (base) => ({
        ...base,
        color: '#3b82f6',
        '&:hover': { background: '#bfdbfe', color: '#1e40af' },
    }),
    option: (base, state) => ({
        ...base,
        background: state.isSelected ? '#1d4ed8' : state.isFocused ? '#eff6ff' : '#fff',
        color: state.isSelected ? '#fff' : '#111827',
        fontSize: 14,
    }),
};

/* ─── component ─────────────────────────────────────────────────────── */
const UrlPermission = () => {
    const [rules, setRules] = useState([]);
    const [roles, setRoles] = useState([]);
    const [activeView, setActiveView] = useState('list');
    const [formData, setFormData] = useState({
        // id: null,
        url_pattern: '',
        Page_name: '',
        app_name: '',
        allowed_roles: [],
    });
    const [isEdit, setIsEdit] = useState(false);

    const token = localStorage.getItem('token');
    const authHeaders = { headers: { Authorization: `Bearer ${token}` } };

    useEffect(() => { fetchData(); }, []);

    const fetchData = async () => {
        try {
            const res = await axios.get(URL_API, authHeaders);
            setRules(res.data.rules);
            setRoles(res.data.roles.map(r => ({ value: r.role_name, label: r.role_name })));
        } catch (err) { console.error(err); }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                // ...formData,
                // allowed_roles: formData.allowed_roles.map(i => i.value),
                url_pattern: formData.url_pattern,
                Page_name: formData.Page_name,
                app_name: formData.app_name,
                allowed_roles: formData.allowed_roles.map(role => role.value),
            };
            if (isEdit) {
                await axios.put(`${URL_UPDATE_API}${formData.id}/`, payload, authHeaders);
            } else {
                await axios.post(URL_ADD_API, payload, authHeaders);
            }
            resetForm();
            fetchData();
            setActiveView('list');
        } catch (err) { console.error(err); }
    };

    const handleEdit = (item) => {
        setIsEdit(true);
        setActiveView('form');
        setFormData({
            id: item.id,
            url_pattern: item.url_pattern,
            Page_name: item.Page_name,
            app_name: item.app_name,
            allowed_roles: item.allowed_roles.map(r => ({ value: r, label: r })),
        });
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this permission?')) return;
        try {
            await axios.delete(`${URL_DELETE_API}${id}/`, authHeaders);
            fetchData();
        } catch (err) { console.error(err); }
    };

    const resetForm = () => {
        setFormData({ id: null, url_pattern: '', Page_name: '', app_name: '', allowed_roles: [] });
        setIsEdit(false);
    };

    const field = (key, value) =>
        setFormData(prev => ({ ...prev, [key]: value }));

    return (
        <div style={styles.page}>
            {/* Google Font */}
            <link
                href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Fira+Mono&display=swap"
                rel="stylesheet"
            />

            {/* ── Banner ── */}
            <div style={styles.banner}>
                <div>
                    <h2 style={styles.bannerTitle}>Permission Management</h2>
                    <p style={styles.bannerSub}>Manage URL access permissions for all roles</p>
                </div>
                <div style={styles.bannerBtns}>
                    <button
                        style={activeView === 'form' ? styles.btnSolidWhite : styles.btnOutlineWhite}
                        onClick={() => { resetForm(); setActiveView('form'); }}
                    >
                        + Add Permission
                    </button>
                    <button
                        style={activeView === 'list' ? styles.btnSolidWhite : styles.btnOutlineWhite}
                        onClick={() => setActiveView('list')}
                    >
                        Permission List
                    </button>
                </div>
            </div>
            <div style={styles.main}>


                {/* ── Form ── */}
                {activeView === 'form' && (
                    <div style={styles.card}>
                        <div style={styles.cardHeader}>
                            <h4 style={styles.cardTitle}>
                                {isEdit ? '✏️  Update Permission' : '➕  Add New Permission'}
                            </h4>
                        </div>
                        <div style={styles.cardBody}>
                            <form onSubmit={handleSubmit}>
                                <div style={styles.formGrid}>

                                    <div>
                                        <label style={styles.label}>URL Pattern</label>
                                        <input
                                            style={styles.input}
                                            type="text"
                                            placeholder="/dashboard/"
                                            value={formData.url_pattern}
                                            onChange={e => field('url_pattern', e.target.value)}
                                            required
                                            onFocus={e => (e.target.style.borderColor = '#3b82f6')}
                                            onBlur={e => (e.target.style.borderColor = '#d1d5db')}
                                        />
                                    </div>

                                    <div>
                                        <label style={styles.label}>Page Name</label>
                                        <input
                                            style={styles.input}
                                            type="text"
                                            placeholder="Dashboard"
                                            value={formData.Page_name}
                                            onChange={e => field('Page_name', e.target.value)}
                                            onFocus={e => (e.target.style.borderColor = '#3b82f6')}
                                            onBlur={e => (e.target.style.borderColor = '#d1d5db')}
                                        />
                                    </div>

                                    <div>
                                        <label style={styles.label}>App Name</label>
                                        <input
                                            style={styles.input}
                                            type="text"
                                            placeholder="Admin App"
                                            value={formData.app_name}
                                            onChange={e => field('app_name', e.target.value)}
                                            onFocus={e => (e.target.style.borderColor = '#3b82f6')}
                                            onBlur={e => (e.target.style.borderColor = '#d1d5db')}
                                        />
                                    </div>

                                    <div style={styles.formGridFull}>
                                        <label style={styles.label}>Allowed Roles</label>
                                        <Select
                                            isMulti
                                            options={roles}
                                            value={formData.allowed_roles}
                                            onChange={sel => field('allowed_roles', sel || [])}
                                            styles={{
                                                ...selectStyles,
                                                menuPortal: base => ({ ...base, zIndex: 9999 })
                                            }}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}
                                            placeholder="Select roles…"
                                        />
                                    </div>

                                </div>

                                <div style={styles.formActions}>
                                    <button type="submit" style={styles.btnPrimary}>
                                        {isEdit ? 'Update Permission' : 'Add Permission'}
                                    </button>
                                    <button type="button" style={styles.btnSecondary} onClick={resetForm}>
                                        Reset
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {/* ── Table ── */}
                {activeView === 'list' && (
                    <div style={styles.card}>
                        <div style={styles.cardHeader}>
                            <h4 style={styles.cardTitle}>Permission List</h4>

                        </div>
                        <div style={{ padding: '16px 28px 28px' }}>
                            <div style={styles.tableWrap}>
                                <table style={styles.table}>
                                    <thead>
                                        <tr>
                                            {['ID', 'Page Name', 'URL Pattern', 'Allowed Roles', 'App', 'Actions'].map(h => (
                                                <th key={h} style={styles.th}>{h}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rules.length > 0 ? rules.map((item, idx) => (
                                            <tr
                                                key={item.id}
                                                style={{
                                                    background: idx % 2 === 0 ? '#fff' : '#fafbfd',
                                                    transition: 'background 0.15s',
                                                }}
                                                onMouseEnter={e => (e.currentTarget.style.background = '#eff6ff')}
                                                onMouseLeave={e => (e.currentTarget.style.background = idx % 2 === 0 ? '#fff' : '#fafbfd')}
                                            >
                                                <td style={styles.tdMuted}>#{item.id}</td>
                                                <td style={{ ...styles.td, fontWeight: 500 }}>{item.Page_name}</td>
                                                <td style={styles.td}>
                                                    <code style={styles.code}>{item.url_pattern}</code>
                                                </td>
                                                <td style={styles.td}>
                                                    {item.allowed_roles.map(r => (
                                                        <span key={r} style={styles.badge}>{r}</span>
                                                    ))}
                                                </td>
                                                <td style={styles.tdMuted}>{item.app_name}</td>
                                                <td style={styles.td}>
                                                    <div style={styles.actionBtns}>
                                                        <button style={styles.btnEdit} onClick={() => handleEdit(item)}>
                                                            Edit
                                                        </button>
                                                        <button style={styles.btnDelete} onClick={() => handleDelete(item.id)}>
                                                            Delete
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan={6} style={styles.emptyRow}>
                                                    No permissions found. Add one to get started.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}

            </div>

            <DashboardFooter />
        </div>
    );
};

export default UrlPermission;
